module.exports = __webpack_public_path__ + "img/eider-logo.585c64b9.png";